import React from 'react';
import './style.css';

const Categories = () => {
  const categories = [
    { 
      name: 'Fashion Jewelry', 
      icons: ['💎', '📿', '💍'], 
      href: '/collection?category=global&search=fashion+jewelry' 
    },
    { 
      name: 'Bags & Travel Accessories', 
      icons: ['🎒', '🧳', '🔐'], 
      href: '/collection?category=global&search=Bags+&+Travel+Accessories=' 
    },
    { 
      name: 'Apparel', 
      icons: ['👕', '👚', '👖'],
      href: '/collection?category=global&search=apparel' 
    },
    { 
      name: 'Mobile Accessories', 
      icons: ['📱', '🔋', '🎧'], 
      href: '/collection?category=global&search=Mobile+Accessories' 
    },
    { 
      name: 'Home & Kitchen', 
      icons: ['🏠', '🍳', '🧹'], 
      href: '/collection?category=global&search=kitchen&ali=keyword' 
    },
    { 
      name: 'Car Accessories', 
      icons: ['🚗', '🔧', '💺'], 
      href: '/collection?category=global&search=Car+Accessories' 
    },
    { 
      name: 'Beauty & Grooming Tools', 
      icons: ['💄', '✂️', '🧴'], 
      href: '/collection?category=global&search=Beauty+&+Grooming+Tools=' 
    },
    { 
      name: 'Pet Products', 
      icons: ['🐾', '🦴', '🧸'], 
      href: '/collection?category=global&search=Pet+Products' 
    }
  ];

  return (
    <div className="cat-supp-container-main">
      <div className="cat-supp-header-section">
        <h1 className="cat-supp-main-title">Categories We Support</h1>
        <p className="cat-supp-description-text">
          Pick your niche. We'll help you source and launch the right products.
        </p>
      </div>
      
      <div className="cat-supp-grid-layout">
        {categories.map((category, index) => (
          <a 
            key={index} 
            href={category.href} 
            className="cat-supp-item-card"
          >
            <div className="cat-supp-icon-wrapper">
              <div className="cat-supp-icons-container">
                {category.icons.map((icon, i) => (
                  <span key={i} className="cat-supp-icon-item">{icon}</span>
                ))}
              </div>
            </div>
            <span className="cat-supp-item-name">{category.name}</span>
            <div className="cat-supp-hover-bg"></div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Categories;